import { RootState as RS } from "../types";
import { BugReportSlice } from "./reducer";

export const getBugReportSlice = (s: RS): BugReportSlice => s.bugReport;

export const getIsBugReportSubmitting = (s: RS) =>
  getBugReportSlice(s).isSubmitting;

export const getIsBugReportModalOpen = (s: RS) => getBugReportSlice(s).isOpen;

export const getBugReportMessage = (s: RS) => getBugReportSlice(s).message;

export const getBugReportStack = (s: RS) => getBugReportSlice(s).errorStack;
